import script from "./ServiceBookOfflineIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceBookOfflineIndex.vue?vue&type=script&setup=true&lang=js"

import "./ServiceBookOfflineIndex.vue?vue&type=style&index=0&id=1f46c2d6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f46c2d6"]])

export default __exports__